import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRealtorContext } from '../context/RealtorContext';
import Card from '../components/ui/Card';
import FormInput from '../components/ui/FormInput';
import Button from '../components/ui/Button';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';

const LoginPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login, currentUser } = useRealtorContext();

  useEffect(() => {
    if (currentUser) {
      navigate('/dashboard');
    }
  }, [currentUser, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    try {
      // Simulate API call for login
      await login(email, password);
      // The login function in RealtorContext does not return a boolean,
      // it sets the currentUser and handles errors internally.
      // So, we just navigate on successful execution of login.
      navigate('/dashboard'); // Redirect to dashboard on successful login
    } catch (err) {
      setError('An unexpected error occurred. Please try again.');
      console.error('Login error:', err);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-100">
      <Navbar />
      <main className="flex-grow flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 mt-6">
        <Card className="max-w-md w-full space-y-8 p-8">
          <div>
            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
              Sign in to your account
            </h2>
          </div>
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <div className="rounded-md shadow-sm -space-y-px">
              <FormInput
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                required
                placeholder="  Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mb-4"
              />
              <FormInput
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

          {/*   {error && <p className="text-red-500 text-sm text-center">{error}</p>} */}

            <div className="flex items-center justify-between">
              <div className="text-sm">
                <a href="#ggg" className="font-medium text-primary hover:text-primary-dark">
                  Forgot your password?
                </a>
              </div>
            </div>

            <div>
              <Button
                type="submit"
                variant="primary"
                size="lg"
                className="w-full"
              >
                Sign in
              </Button>
            </div>
          </form>
          <div className="text-center text-sm text-gray-600 mt-4">
            Don't have an account?{' '}
            <a href="/register" className="font-medium text-primary hover:text-primary-dark">
              Sign up
            </a>
          </div>
        </Card>
      </main>
      <Footer />
    </div>
  );
};

export default LoginPage;